import React from 'react';
import {
    OrderSummary,
    OrderSummaryPrice,
    OrderSummaryPrices,
    OrderSummaryCoupons,
    OrderSummaryCoupon,
    Typography,
} from '@hpstellar/core/visId';

import { Helpers } from '../../../core/src/helpers';
import useCartState from '../../../hooks/useCartState';
import useDeviceInfo from '../../../hooks/useDeviceInfo';
import PromoCode from './promo-code';
import ZipCode from './zip-code-input';
import ConsumerFinanceWidget from './consumer-finance-widget';

const pickRewardsAdjustments = cartView => {
    const { adjustment } = cartView || {};

    return (adjustment || []).filter(
        ({ description, displayLevel }) => description === 'Loyalty Rewards' && displayLevel === 'Order',
    );
};

const OrderSummaryDetails = ({ device }) => {
    const { cartInfo, cartViewIsLoading, cartDetailsIsLoading } = useCartState();
    const { cartView, cartDetails } = cartInfo || {};
    const { totalSavings } = cartDetails || {};
    const {
        grandTotal,
        x_shipAmt: shippingCharge,
        x_tax,
        orderItem,
        x_subTotal,
        x_recycleFee,
        x_totalGM,
    } = cartView || {};
    const [firstItem] = orderItem || [];
    const { zipCode } = firstItem || {};
    const savingsAmount = Helpers.convertPriceToNumber(totalSavings);
    const hasSavings = savingsAmount > 0;
    const shippingAmount = Helpers.convertPriceToNumber(shippingCharge);
    const recyclingFee = Helpers.convertPriceToNumber(x_recycleFee);
    const coupons = pickRewardsAdjustments(cartView);
    if (cartViewIsLoading || cartDetailsIsLoading) {
        return <div style={{ height: '370px' }} />;
    }

    return (
        <>
            {device === 'mobile' && <PromoCode variation="toggle" />}
            {hasSavings && (
                <OrderSummaryCoupons price={Helpers.formatCurrency(savingsAmount)} title="Total savings">
                    {coupons?.length > 0 &&
                        coupons.map(({ amount }) => (
                            <OrderSummaryCoupon
                                label="Including HP Rewards"
                                price={Helpers.formatCurrency(amount * -1, undefined, true)}
                            />
                        ))}
                </OrderSummaryCoupons>
            )}
            {x_totalGM && <OrderSummaryCoupons price={x_totalGM} title="GM Points:" />}
            <OrderSummaryPrices className="order-details-prices">
                <OrderSummaryPrice label="Subtotal" value={Helpers.formatCurrency(x_subTotal, undefined, true)} />
                <OrderSummaryPrice
                    label="Shipping"
                    value={
                        shippingAmount > 0 ? (
                            Helpers.formatCurrency(shippingAmount, undefined, true)
                        ) : (
                            <span style={{ color: '#087A00' }}>Free</span>
                        )
                    }
                />
                {recyclingFee > 0 && (
                    <OrderSummaryPrice
                        label="Estimated CA recycling fees"
                        value={Helpers.formatCurrency(recyclingFee)}
                    />
                )}
                <OrderSummaryPrice
                    className="order-details-tax"
                    label="Estimated Tax"
                    value={Helpers.formatCurrency(x_tax)}
                />
                <OrderSummaryPrice className="order-details-zipCode" label={<ZipCode zipCode={zipCode} />} />
            </OrderSummaryPrices>
            <OrderSummaryPrice
                label="Total"
                value={<Typography weight={700}>{Helpers.formatCurrency(grandTotal, undefined, true)}</Typography>}
            />
        </>
    );
};

export default ({ title = 'Order Summary' }) => {
    const { device } = useDeviceInfo(['device'], 'default');

    return (
        <>
            <div className="order-details">
                <OrderSummary className="order-details-summary" title={title}>
                    <OrderSummaryDetails device={device} />
                    <ConsumerFinanceWidget />
                </OrderSummary>
            </div>
            {device !== 'mobile' && <PromoCode />}
        </>
    );
};
